import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { subtaskResourceType } from "./subtaskResourceConsts";

export const subtaskIdentifierStruct = createIdentifierStruct(
  subtaskResourceType
);
